import { Component, OnInit, Inject } from '@angular/core';
import { DropzoneConfigInterface } from 'ngx-dropzone-wrapper';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import {Router} from "@angular/router"
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-digital-add',
  templateUrl: './digital-add.component.html',
  styleUrls: ['./digital-add.component.scss']
})
export class DigitalAddComponent implements OnInit {

  public collegeinfoForm: FormGroup;
  public countries=[];
  public states=[];
  public cities =[];
  public colleges=[];
  public ownerships=[];
  public approvedby=[];
  isShown: boolean = false ;
  submitted = false;
  message = null;
  class = null;
  actionButton;
  action = null;

  constructor(private formBuilder: FormBuilder,  private http: HttpClient, private router: Router, @Inject('API_ENDPOINT') private api_endpoint: string) { }

  public config1: DropzoneConfigInterface = {
    clickable: true,
    maxFiles: 1,
    autoReset: null,
    errorReset: null,
    cancelReset: null
  };

  public onUploadInit(args: any): void { }

  public onUploadError(args: any): void { }

  public onUploadSuccess(args: any): void { }

  public reg = '(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?';

  ngOnInit() {
    this.collegeinfoForm = this.formBuilder.group({
      title: ['', Validators.required],
      collegeurl: ['', [Validators.required, Validators.pattern(this.reg)]],
      established: ['', [Validators.required]],
      collegecontact: ['', Validators.required],
      collegeemail: ['', [Validators.required, Validators.email]],
      ownership: ['', Validators.required],
      approvedby: ['', Validators.required],
      collegeaddress: ['', Validators.required],
      status: ['', Validators.required],
      country: ['', Validators.required],
      state: ['', Validators.required],
      city: ['', Validators.required],
      scholarship: ['', Validators.required],
      scholarshipamt: ['',],
      contactperson: ['', Validators.required],
      contactno: ['', Validators.required],
      contactemail: ['', [Validators.required, Validators.email]],
      about: ['', Validators.required],
      highlights: ['', Validators.required],
      metatitle: ['', Validators.required],
      metadescription: ['', Validators.required],
      keywords: ['', Validators.required],
      tags: ['', Validators.required],
      logo: ['',],
      collegeid: ['', Validators.required],
      _id: ['',],
    });

    this.http.get<any>(this.api_endpoint+'/country/').subscribe(
        data => {
          this.countries = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
    
    this.http.get<any>(this.api_endpoint+'/colleges/').subscribe(
        data => {
          this.colleges = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

    this.http.get<any>(this.api_endpoint+'/ownership/').subscribe(
        data => {
          this.ownerships = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

    this.http.get<any>(this.api_endpoint+'/colleges/').subscribe(
        data => {
          this.approvedby = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });

    
  }

  scholarshipamt(value){
    if(value == 'Enable'){
      this.isShown =  true;
    }else if(value == 'Disable'){
      this.collegeinfoForm.patchValue({
        scholarshipamt: "",
      });
      this.isShown =  false;
    }
  }
  

  getstates(value){
    this.http.get<any>(this.api_endpoint+'/statec/' + value).subscribe(
        data => {
          this.states = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getcities(state){
    this.http.get<any>(this.api_endpoint+'/citys/' + state).subscribe(
        data => {
          this.cities = data.data;
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  getinfo(value){
    this.http.get<any>(this.api_endpoint+'/collegebyid/' + value).subscribe(
        data => {
          console.log(data.data);
          if(data.data != null){
            this.action = 'Update';
            if(data.data.scholarship){
              this.isShown =  true;
            }else{
              this.isShown =  false;
            }
            this.collegeinfoForm.patchValue({
              _id: data.data._id,
              title: data.data.title,
              collegeurl: data.data.collegeurl,
              established: data.data.established,
              collegecontact: data.data.collegecontact,
              collegeemail: data.data.collegeemail,
              ownership: data.data.ownership,
              approvedby: data.data.approvedby,
              collegeaddress: data.data.collegeaddress,
              status: data.data.status,
              country: data.data.country,
              state: data.data.state,
              city: data.data.city,
              scholarship: data.data.scholarship,
              scholarshipamt: data.data.scholarshipamt,
              contactperson: data.data.contactperson,
              contactno: data.data.contactno,
              contactemail: data.data.contactemail,
              about: data.data.about,
              highlights: data.data.highlights,
              metatitle: data.data.metatitle,
              metadescription: data.data.metadescription,
              keywords: data.data.keywords,
              tags: data.data.tags,
              
            });
          }else{
            this.action = 'Submit';
            // this.collegeinfoForm.reset();
            this.collegeinfoForm.patchValue({
              _id: "",
              title: "",
              collegeurl: "",
              established: "",
              collegecontact: "",
              collegeemail: "",
              ownership: "",
              approvedby: "",
              collegeaddress: "",
              status: "",
              country: "",
              state: "",
              city: "",
              scholarship: "",
              scholarshipamt: "",
              contactperson: "",
              contactno: "",
              contactemail: "",
              about: "",
              highlights: "",
              metatitle: "",
              metadescription: "",
              keywords: "",
              tags: "",
            });
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  }

  get f() { return this.collegeinfoForm.controls; }

  onSubmit(action){
    console.log(this.collegeinfoForm.value);

    this.submitted = true;

    if (this.collegeinfoForm.invalid) {
      alert(this.collegeinfoForm.invalid);
      return;
      
    }
    // console.log(this.collegeinfoForm.value);
    if(action == 'Update'){
      alert(action);
      this.http.put<any>(this.api_endpoint+'/collegeinfo', this.collegeinfoForm.value).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        }
        // window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });

    }else if(action == 'Submit'){
      alert(action);
      delete this.collegeinfoForm.value._id;
      // console.log(this.collegeinfoForm.value);
    this.http.post<any>(this.api_endpoint+'/collegeinfo', this.collegeinfoForm.value).subscribe(
      res => {
        console.log(res);
        if(res.Error){
          this.message = res.Error;
          this.class = 'btn btn-primary';
          return
        }else{
          this.message = 'Successfully Added';
          this.class = 'btn btn-success';
        }
        // window.location.reload();
    },
    (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.log("Client-side error occured.");
      } else {
        console.log("Server-side error occured.");
      }
    });
  }
  }

}
